//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { list: [], stats: null } },
  created () {
    this.$ajax.get(this.$api.slSentenceCollections).then(r => { this.list = r || [] }).catch(() => {})
    this.$ajax.get(this.$api.slUserStats).then(r => { this.stats = r }).catch(() => {})
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/collections.vue